import {defineStore} from 'pinia';
import {ModuleDataManagementList} from '@/stores/moduleConst';

const action = {
  setMessage(message) {
    this.database_id = message.DatabaseId;
    this.CurrentPercent = message.CurrentPercent;
    this.database_name = message.DatabaseName ? message.DatabaseName : this.database_name;
    this.created_by = message.CreatedBy ? message.CreatedBy : this.created_by;
    this.created_date = message.CreatedDate ? message.CreatedDate : this.created_date;
    this.status = message.DatabaseStatus ? message.DatabaseStatus : this.status;
    this.UserId = message.UserId;
    // Source = 'circular' cho event update_circular (TT107) — phân biệt với convert Panda.NET.
    // Legacy convert events không set Source → reset về null để không bị stale từ circular trước.
    this.Source = message.Source ?? null;
    // Success/ErrorMessage: event tiến trình (converting/update_circular progress) không gửi field Success
    // (undefined) nên giữ nguyên giá trị cũ. Khi field có mặt (kể cả null — optimistic setMessage lúc bắt đầu
    // task mới) thì ghi đè, để không bị dính Success=true/false stale từ task trước đó.
    if (message.Success !== undefined) {
      this.Success = message.Success;
      this.ErrorMessage = message.ErrorMessage ?? '';
    }
  },
  endMessage() {},
};
export const useDataManagementStore = defineStore(ModuleDataManagementList, {
  state: () => ({
    database_id: null,
    database_name: null,
    created_by: null,
    created_date: null,
    CurrentPercent: null,
    UserId: null,
    status: 3,
    // Nguồn message: 'circular' = tách dữ liệu TT107, null/undefined = convert Panda.NET
    Source: null,
    // Trạng thái hoàn thành tách dữ liệu: null = đang xử lý, true = thành công, false = lỗi
    Success: null,
    ErrorMessage: '',
  }),
  actions: action,
});
